import styled from 'styled-components'
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles";

export const HomeNewsWrapper = styled.section`
	font-family: Poppins, sans-serif;

	h2 {
		text-align: center;
		color: ${FlexipageColors.blue1000};
		margin: 0;
		text-wrap: balance;

		font-size: ${headingSizes.h4.desktop[0]};
		line-height: ${headingSizes.h4.desktop[1]};
		font-family: ${headingSizes.h4.fontFamily};
		font-weight: ${headingSizes.h4.fontWeight};

		@media (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: ${headingSizes.h4.tablet[0]};
			line-height: ${headingSizes.h4.tablet[1]};
		}

		@media (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: ${headingSizes.h4.mobile[0]};
			line-height: ${headingSizes.h4.mobile[1]};
		}
	}

	.intro {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		gap: 2.5rem;
		margin-bottom: 3.5rem;

		a {
			display: inline-flex;
			align-items: center;
			gap: 0.5rem;
			color: ${FlexipageColors.blue1000};

			svg {
				height: 1rem;
				color: inherit;
				flex-shrink: 0;
			}

			&:hover {
				text-decoration: underline;
			}

			&:focus-visible {
				outline: 2px solid ${FlexipageColors.blue1000};
				outline-offset: 2px;
			}
		}
	}

	.articles {
		display: grid;
		grid-template-columns: 1fr;
		gap: 2rem;

		@media (min-width: 768px) {
			grid-template-columns: repeat(2, 1fr);
			gap: 1.5rem;
		}

		@media screen and (min-width: 1200px) {
			grid-template-columns: repeat(4, 1fr);
			gap: 1rem;
		}
	}

	article {
		--_bg-color: #41a4a0;
		--_cat-color: #ffffff;
		--_heading-color: ${FlexipageColors.blue1000};
		--_top-circle-color: #55b9a3;
		--_bottom-circle-color: ${FlexipageColors.blue1000};

		@media screen and (max-width: 767px), screen and (min-width: 1200px) {
			&:nth-child(even) {
				--_bg-color: ${FlexipageColors.blue1000};
				--_cat-color: #55b9a3;
				--_heading-color: #ffffff;
				--_top-circle-color: ${FlexipageColors.blue1200};
				--_bottom-circle-color: #1d6081;
			}
		}

		@media screen and (min-width: 768px) and (max-width: 1200px) {
			&:nth-child(2), &:nth-child(3) {
				--_bg-color: ${FlexipageColors.blue1000};
				--_cat-color: #55b9a3;
				--_heading-color: #ffffff;
				--_top-circle-color: ${FlexipageColors.blue1200};
				--_bottom-circle-color: #1d6081;
			}
		}

		position: relative;
		z-index: 1;
		display: grid;
		grid-template-rows: auto 1fr;

		background-color: var(--_bg-color);
		border-radius: 1rem;
		overflow: hidden;

		transition: scale 0.1s ease-in-out;

		&:has(a:hover, a:focus-visible) {
			scale: 1.02;
		}

		&:has(a:focus-visible) {
			outline: 2px solid ${FlexipageColors.blue1000};
			outline-offset: 2px;
		}

		> * {
			grid-column: 1;
		}

		.image {
			grid-row: 1;
			aspect-ratio: 356 / 224;

			position: relative;
			z-index: 10;

			img {
				position: absolute;
				inset: 0;
				object-fit: cover;
				width: 100%;
				height: 100%;
			}
		}

		.content {
			grid-row: 2;
			z-index: 10;

			display: flex;
			flex-direction: column;
			gap: 1rem;

			padding: 1.5rem;
			padding-right: 4.5rem;

			.category {
				color: var(--_cat-color);
			}

			h3 {
				font-size: 20px;
				line-height: 1.2;
				font-weight: 500;
				color: var(--_heading-color);
				margin: 0;

				a {
					color: inherit;
					outline: 0 none;

					&::after {
						content: "";
						position: absolute;
						inset: 0;
						z-index: 50;
					}
				}
			}
		}

		.circles {
			display: grid;
			grid-template-areas: "stack";
			grid-row: 1 / -1;
			grid-column: 1 / -1;

			position: absolute;

			.circle {
				grid-area: stack;
				border: 1px solid var(--_circle-color);
				border-radius: 50%;
			}

			.circle:nth-child(2) {
				translate: 1rem;
			}

			.circle:nth-child(3) {
				translate: 2rem;
			}

			.circle:nth-child(4) {
				translate: 3rem;
			}

			.circle:nth-child(5) {
				translate: 4rem;
			}

			.circle:nth-child(6) {
				translate: 5rem;
			}

			&.top {
				top: 0;
				right: 0;

				width: 392px;
				height: 462px;

				rotate: -35.948deg;
				translate: 60% -50%;

				--_circle-color: var(--_top-circle-color);
			}

			&.bottom {
				bottom: 0;
				right: 0;

				aspect-ratio: 272 / 331;

				width: 272px;

				translate: 70% 60%;

				--_circle-color: var(--_bottom-circle-color);
			}
		}

		@media screen and (max-width: 439px) {
			.content {
				padding-right: 2rem;
			}

			.circles {
				&.bottom {
					width: 186px;
				}
			}
		}
	}
`;